import React from 'react';
import { Form, Input, Button, Card, message, Row, Col } from 'antd';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { addBDE, fetchBDEs } from '../../store/bdeSlice';
import { formatName, formatMobile } from '../../utils/formatters';

const Register = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onFinish = async (values) => {
    try {
      const formattedName = formatName(values.name);
      const formattedMobile = formatMobile(values.mobile);

      // Check if user exists (this check should ideally be server side but for mock...)
      const result = await dispatch(fetchBDEs()).unwrap();
      if (result.find(u => u.mobile === formattedMobile)) {
        message.error('Mobile number already registered');
        return;
      }

      const workingPincodes = String(values.workingPincodes || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);

      const newUser = {
        id: `BDE-${Date.now()}`,
        name: formattedName,
        email: values.email,
        mobile: formattedMobile,
        address: values.address,
        pincode: values.pincode,
        whatsappNumber: values.whatsappNumber,
        companyName: values.companyName,
        workingPincodes,
        status: 'pending',
        createdAt: new Date().toISOString().split('T')[0],
        role: 'bde',
      };

      await dispatch(addBDE(newUser)).unwrap();
      message.success('Registration successful. Please wait for admin approval.');
      navigate('/login');
    } catch (err) {
      message.error('Registration failed: ' + err);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
      position: 'relative',
      padding: '24px 0', // Add padding for mobile scrolling
      overflowX: 'hidden' // Only hide horizontal overflow
    }}>
      {/* Decorative blobs */}
      <div style={{ position: 'absolute', top: -100, left: -100, width: 400, height: 400, background: '#2563eb', filter: 'blur(150px)', opacity: 0.2, borderRadius: '50%' }}></div>
      <div style={{ position: 'absolute', bottom: -100, right: -100, width: 400, height: 400, background: '#8b5cf6', filter: 'blur(150px)', opacity: 0.2, borderRadius: '50%' }}></div>

      <Card
        style={{ width: 900, border: '1px solid rgba(255,255,255,0.1)' }}
        styles={{ body: { padding: '32px' } }}
      >
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h1 style={{ color: '#fff', margin: 0, fontSize: 24 }}>B2B REGISTRATION</h1>
          <p style={{ color: '#94a3b8', marginTop: 8 }}>Create your BDE account</p>
        </div>
        <Form
          name="register"
          onFinish={onFinish}
          layout="vertical"
        >
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Form.Item
                name="email"
                label={<span style={{ color: '#94a3b8' }}>Email</span>}
                rules={[
                  { required: true, message: 'Please input your email!' },
                  { type: 'email', message: 'Please enter a valid email!' }
                ]}
              >
                <Input placeholder="john@example.com" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="name"
                label={<span style={{ color: '#94a3b8' }}>Name</span>}
                rules={[{ required: true, message: 'Please input your name!' }]}
              >
                <Input placeholder="John Doe" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="mobile"
                label={<span style={{ color: '#94a3b8' }}>Phone Number</span>}
                rules={[
                  { required: true, message: 'Please input your mobile number!' },
                  { pattern: /^[0-9]{10}$/, message: 'Please enter a valid 10-digit mobile number!' }
                ]}
              >
                <Input placeholder="9876543210" maxLength={10} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="whatsappNumber"
                label={<span style={{ color: '#94a3b8' }}>WhatsApp Number</span>}
                rules={[
                  { required: true, message: 'Please input WhatsApp number!' },
                  { pattern: /^[0-9]{10}$/, message: 'Please enter a valid 10-digit number!' }
                ]}
              >
                <Input placeholder="9876543210" maxLength={10} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="pincode"
                label={<span style={{ color: '#94a3b8' }}>Pincode</span>}
                rules={[
                  { required: true, message: 'Please input your pincode!' },
                  { pattern: /^[0-9]{6}$/, message: 'Please enter a valid 6-digit pincode!' }
                ]}
              >
                <Input placeholder="110001" maxLength={6} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="address"
                label={<span style={{ color: '#94a3b8' }}>Address</span>}
                rules={[{ required: true, message: 'Please input your address!' }]}
              >
                <Input.TextArea placeholder="123 Main St, City, State" rows={3} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="companyName"
                label={<span style={{ color: '#94a3b8' }}>Working Company Name</span>}
                rules={[{ required: true, message: 'Please input company name!' }]}
              >
                <Input placeholder="Company Pvt Ltd" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="workingPincodes"
                label={<span style={{ color: '#94a3b8' }}>Working Pincodes (comma separated)</span>}
                rules={[{ required: true, message: 'Please input working pincodes!' }]}
              >
                <Input placeholder="110001, 110002" />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Button type="primary" htmlType="submit" block size="large" style={{ marginTop: 16 }}>
              Register Account
            </Button>
          </Form.Item>

          <Button type="link" block onClick={() => navigate('/login')} style={{ color: '#64748b' }}>
            Already have an account? Login
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default Register;
